import type { FaireProductEntity } from "../../entity_types/product";

export const p_9awkju38d9: FaireProductEntity = {
  token: "p_9awkju38d9",
  type: "product",
  name: "DETP60050-CONTRAST STITCHES TOP ELASTIC WAIST PANTS SET",
  brandToken: "b_40gau4dz8q",
  brandName: "Davi & Dani",
  imageUrl:
    "https://cdn.faire.com/fastly/73a4d534014a1abfd12892ceb8553ea367637fdc2e6bb465007e199eb759324c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/75d575d2eeb964afe224b47acaa7821a5803fe69f82d9cfe8ed73f8e7ec285fb.jpeg",
    "https://cdn.faire.com/fastly/bfb9ec1f402b19f90592bf8469bb06f5f3fda0a6f789cb335932e46a29309011.jpeg",
    "https://cdn.faire.com/fastly/7e01eacfd988e3f1c637cbe50a8c7c9af2afb6b8519981edd9f25c9bcab78e18.jpeg",
    "https://cdn.faire.com/fastly/1d6a5d6bbcceea22342e263f48b6165842a24cd909ea1bd22f277a0b7d3a121c.jpeg",
    "https://cdn.faire.com/fastly/a53348cdb1ff15c1f5b63208f6b40d7a27f8b8e595a3583cccfb60f0875f2a41.jpeg",
    "https://cdn.faire.com/fastly/7c83387728d2ca42c0a285e1be48ce258e8315bbd126dc4619df8246c6fdafc9.jpeg",
    "https://cdn.faire.com/fastly/411f61799ebc529ddf943ff5db0ff51dcc91978081af95ed2b7784cbc223177f.jpeg",
    "https://cdn.faire.com/fastly/b0f95ebcf48239316e291656e70af0dbecbbe8d1b742ca06383d489b18784a26.jpeg",
    "https://cdn.faire.com/fastly/9604ca553741c19389e03fb868288d94cd161f56ea5d8cbede615844cdef3bcb.jpeg",
    "https://cdn.faire.com/fastly/62a6c0665c88f9c679efe307d07121f3d1f79ed04e902a60b4dfe586d9cd02db.png",
    "https://cdn.faire.com/fastly/b53ffe119965ec5daee507fa791bf9405b90afef45f9493a8404ce164b72271b.png",
    "https://cdn.faire.com/fastly/ca1be10f9c4d165e981acc7954c139cbd4aa4ed6a1085c5edff620a7a34f1282.png",
    "https://cdn.faire.com/fastly/578b12bdacd0ee0b27e0d54003c3168ab02dc340680fc82ed3e35b80af2df279.png",
    "https://cdn.faire.com/fastly/8748a06cbea56b81d415e6704fe767cfb10f255cb9435fcc5a9de12eeaabb637.png",
    "https://cdn.faire.com/fastly/622fd5d8756a5f5968e44824a9ee527ba8a6c5572533b21dcd6caa6c6586fd90.png",
  ],
  priceDollars: 215.4,
  description:
    'Curate your athleisure selection with this elevated Contrast Stitch Two Piece Set. The sleeveless crop top and wide leg pant feature bold stitching details, moving this beyond basic loungewear. This comfortable yet refined set is perfect for the young contemporary buyer. Invest in this coveted style now to define your seasonal collection\r\n\r\nModel is wearing Small\r\nHeight: 5\'10"\r\nBust : 34\r\nWaist : 25"\r\nHips : 35"',
  tags: [],
  msrpDollars: 430.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:51.449Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
